import { render, staticRenderFns } from "./CostStatementCard.vue?vue&type=template&id=ce9174c0&scoped=true"
import script from "./CostStatementCard.vue?vue&type=script&lang=js"
export * from "./CostStatementCard.vue?vue&type=script&lang=js"
import style0 from "./CostStatementCard.vue?vue&type=style&index=0&id=ce9174c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9174c0",
  null
  
)

export default component.exports